<template>
    <v-container class="pa-5" fluid>
        <JobPlatesDialog
            :is-open="jobPlatesDialog"
            :job-data="currentJob"
            @get-jobs="getJobs"
            @get-aggregated-jobs="getAggregatedJobs"
            @on-show="showJobPlatesDialog"
            @on-close="closeJobPlatesDialog"
        />
        <page-title>Lista zleceń</page-title>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col v-for="(machine, index) in machines" :key="index" cols="auto">
                            <v-badge
                                :content="machine.prepressJobsAmount === 0 ? '0' : machine.prepressJobsAmount"
                                color="primary"
                                overlap
                            >
                                <v-btn
                                    large
                                    :color="machine.isSelected ? 'success' : 'primary'"
                                    :outlined="!machine.isSelected"
                                    class="ml-4"
                                    @click="updateFilter(machine)"
                                >
                                    {{ machine.machineSymbol }}
                                </v-btn>
                            </v-badge>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="jobs"
                        :loading="jobsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="jobsData"
                        @pagination="updatePagination"
                    >
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Otwórz"
                                            v-on="on"
                                            @click="showJobPlatesDialog(item)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import JobPlatesDialog from './JobPlatesDialog'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'

export default {
    name: 'PrepressJobs',
    components: {
        PageTitle,
        JobPlatesDialog
    },
    mixins: [
        pagination,
        tooltipDelay,
        filters,
        dateFormatter,
        customFilters
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('prepress/clearJobsFilters')
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            currentJob: null,
            jobPlatesDialog: false,
            headers: [
                {
                    text: 'Numer zlecenia',
                    value: 'number',
                    sortable: false,
                },
                {
                    text: 'Ilość montaży',
                    value: 'platesAmount',
                    sortable: false,
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        jobs() {
            return this.$store.state.prepress.prepressJobs.jobs
        },
        jobsLoading() {
            return this.$store.state.prepress.prepressJobs.jobsLoading
        },
        savedFilters() {
            return this.$store.state.prepress.prepressJobs.filters
        },
        machines() {
            return this.$store.state.prepress.prepressJobs.machines
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    if (item === 'status') {
                        filters[item] = 10
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getAggregatedJobs()
        this.getJobs()
    },
    methods: {
        getAggregatedJobs() {
            this.$store.dispatch('prepress/getAggregatedJobs')
                .catch(error => {
                    errorHandler(error)
                })
        },
        getJobs() {
            this.$store.dispatch('prepress/getJobs', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showJobPlatesDialog(job) {
            this.currentJob = job
            this.jobPlatesDialog = true
        },
        closeJobPlatesDialog() {
            this.jobPlatesDialog = false
        },
        updateFilter(machine) {
            machine.isSelected = !machine.isSelected

            const index = this.filters.machineIds.findIndex(item => item === machine.machineId)

            if (index > -1) {
                this.filters.machineIds.splice(index, 1)
            } else {
                this.filters.machineIds.push(machine.machineId)
            }

            this.changeFilter()
        },
        changeFilter() {
            this.$store.dispatch('prepress/setJobsFilters', this.filters)
            this.resetPagination()
            this.getJobs()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getJobs()
            }

            this.clearPaginationPending()
        }
    }
}
</script>
